import styled from "styled-components";
import { COLORS, responsive } from "../../../../styles/constants.style";

export const HierarchyModalWrapper = styled.div`
  position: relative;

  .react-transform-wrapper {
    width: auto;
    min-height: 445px;
    background-color: ${COLORS.cirrus_black1};
    border-bottom: 1px solid ${COLORS.cirrus_black3};
  }

  .drag-buttons-container {
    position: absolute;
    top: 24px;
    right: 16px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    align-items: center;

    .horizontal-buttons-container {
      display: flex;
      gap: 34px;
    }
  }

  .zoom-buttons-container {
    position: absolute;
    bottom: 16px;
    right: 16px;
    z-index: 10;
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .MuiIconButton-root {
    background-color: ${COLORS.primary_light_blue};
    border-radius: 4px;
    height: 34px;
    width: 34px;
    &:hover {
      background-color: ${COLORS.primary_light_blue};
    }
  }
`;

export const StyledNode = styled.div`
  border-radius: 8px;
  border: 1px solid ${COLORS.cirrus_black4};
  background: ${COLORS.primary_light_blue1};
  display: inline-block;

  .container {
    display: flex;
    align-items: center;

    .details-wrapper {
      display: flex;
      flex-direction: column;
      gap: 3px;
      padding: 18px 16px;

      .MuiTypography-root.MuiTypography-h2SemiBold {
        line-height: 20px;
        color: ${COLORS.cirrus_black};
        width: 250px;
        text-align: left;
      }

      .MuiTypography-root.MuiTypography-h3Bold {
        line-height: 22px;
        color: ${COLORS.cirrus_black8};
        text-align: left;
      }

      .location-container {
        display: flex;

        .MuiTypography-root.MuiTypography-h3Bold {
          color: ${COLORS.primary_dark_blue7};
        }

        .city-content {
          max-width: 150px;
        }
      }
    }
  }

  .MuiAvatar-root {
    width: 72px;
    height: 72px;
    margin-left: 16px;
    background-color: ${COLORS.primary_light_blue3};
    .MuiTypography-h2SemiBold {
      color: ${COLORS.cirrus_black};
      line-height: 20px;
    }
  }
`;

export const AccordionListWrapper = styled.div`
  padding: 24px;
  height: 445px;
  overflow: auto;

  ${responsive.MOBILE`
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    `}

  .header-row,
  .details-row {
    display: flex;
    min-width: 768px;
  }

  .header-row {
    background-color: ${COLORS.primary_light_blue3};
    display: flex;
    padding: 13px 0px;

    .tableHeader {
      line-height: 21.78px;
      color: ${COLORS.cirrus_black};
    }
    .nameHeader {
      padding-left: 16px;
    }
  }

  .first-column {
    width: 50%;
  }

  .second-column {
    width: 20%;
  }

  .third-column {
    width: 30%;
  }

  .MuiPaper-root::before {
    height: 0px;
  }

  .MuiAccordion-root:nth-of-type(even) {
    background-color: ${COLORS.primary_light_blue1};
  }

  .MuiPaper-root {
    margin: 0;
    box-shadow: none;
  }

  .MuiAccordion-root:first-of-type,
  .MuiAccordion-root:last-of-type {
    border-radius: 0px;
  }

  .MuiAccordion-root.Mui-expanded {
    margin: 0;
  }

  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 52px;
  }

  .MuiAccordionDetails-root {
    padding: 0;
  }

  .details-row {
    display: flex;
    justify-content: space-between;
    min-height: 52px;
    padding: 0;

    .MuiAccordionSummary-content {
      margin: 0;

      .MuiIconButton-root {
        height: 40px;
        width: 40px;
      }
    }

    .d-flex-center {
      display: flex;
      align-items: center;
    }

    .first-column {
      .name-container {
        padding-left: 16px;
        h3 {
          padding-left: 10px;
          max-width: 250px;
        }

        .empty-child-content {
          padding-left: 50px;
        }
      }
    }
    .third-column {
      .city-content {
        max-width: 150px;
      }
    }
  }

  .MuiCollapse-root .MuiAccordionDetails-root .details-row {
    padding: 0;
  }
`;
